export default __webpack_public_path__ + "static/media/planet-saturn-internal.e883c559.svg";